import moment from 'moment';

export const dateFormat = (date, dateFormat) => 
{
    return moment(date).format(dateFormat);
}